import axios from "../utils/demoaxios";

export default class service {
  static baseURL = "";

  static getConstant(data) {
    return axios.get();
  }

  

}


